import { createHistoryRouter, RouteParams } from 'atomic-router';
import { LinkProps } from 'atomic-router-react';
import { useUnit } from 'effector-react';
import { ReactNode, Children, isValidElement, ReactElement } from 'react';

export const useActiveRouteGroup = (
	children: ReactNode,
	router: ReturnType<typeof createHistoryRouter>,
) => {
	const [activeRoutes, path] = useUnit([router.$activeRoutes, router.$path]);

	const routes = Children.toArray(children)
		.filter(isValidElement)
		.filter(
			(el): el is ReactElement<LinkProps<RouteParams>> =>
				typeof el.props === 'object' && el.props !== null && 'to' in el.props,
		)
		.map((el) => el.props.to);

	const active = routes.some((r) =>
		typeof r === 'string' ? path === r : activeRoutes.includes(r),
	);

	return active;
};
